import firebase from 'firebase/app';
import 'firebase/auth';

export default (): string | undefined => {
    return firebase.auth().currentUser?.uid;
};
